const config = {
  "api_url": "https://api.optios.net",
  "client_url": "",
  "recaptchaSiteKey": "6LeuIiQoAAAAAFvRsgHetDXziF60zp2srRiqcZSr"
}

export default config;
